import React, { FunctionComponent } from 'react';

export const Home : FunctionComponent = ()=> {
  return (
    <>
      <div className="preview-result">
        蔡司资源管理系统
      </div>
    </>    
  );
}
